// extracted by mini-css-extract-plugin
export default {"root":"styles_root__03DvJ","password-note":"styles_password-note__08JFb","form":"styles_form__da-02","input":"styles_input__9079P"};